import { useContext } from 'react';
import { ValidationContext } from './Context';

export const useValidationContext = () => {
  const context = useContext(ValidationContext);

  return context;
};
